import { Box, useTheme } from "@mui/material";
import { Typography } from "@pmag/ui-components";
import { Routes } from "@src/context/router/RouterContext";
import { useRouter } from "@src/hooks/useRouter";
import { useCheckRegionAttribute } from "@src/main/useCheckRegionAttribute";
import { CompatibilityCheckPage } from "@src/pages/compatibilityCheck/CompatibilityCheckPage";
import { ComponentGroupOverviewPage } from "@src/pages/componentGroupOverview/ComponentGroupOverviewPage";
import { LandingPage } from "@src/pages/landingPage/LandingPage";
import { SearchResultPage } from "@src/pages/searchResult/SearchResultPage";
import { SubGroupDetailPage } from "@src/pages/subGroupDetail/SubGroupDetailPage";
import { VisualSelectorPage } from "@src/pages/visualSelectorPage/VisualSelectorPage";
import { WishlistPage } from "@src/pages/wishlist/WishlistPage";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

export const dataTestId = {
    container: "sparePartsFinder.main.container",
};

const Main: FunctionComponent = () => {
    const { currentRoute } = useRouter();

    useCheckRegionAttribute();
    const theme = useTheme();

    return (
        <Box data-testid={dataTestId.container} bgcolor={theme.palette.core.white}>
            <Box mb={3} pt={4}>
                <Typography variant="heading-04">
                    <FormattedMessage id="sparePartsFinder.title" defaultMessage="SPARE PARTS FINDER" />
                </Typography>
            </Box>

            {currentRoute === Routes.Landing && <LandingPage />}

            {currentRoute === Routes.SearchResult && <SearchResultPage />}

            {currentRoute === Routes.VisualSelector && <VisualSelectorPage />}

            {currentRoute === Routes.ComponentGroupOverview && <ComponentGroupOverviewPage />}

            {currentRoute === Routes.SubGroupDetail && <SubGroupDetailPage />}

            {currentRoute === Routes.CompatibilityCheck && <CompatibilityCheckPage />}

            {currentRoute === Routes.Wishlist && <WishlistPage />}
        </Box>
    );
};

export { Main };
